import { render, staticRenderFns } from "./getCode.vue?vue&type=template&id=d04d7304&scoped=true&"
import script from "./getCode.vue?vue&type=script&lang=js&"
export * from "./getCode.vue?vue&type=script&lang=js&"
import style0 from "./getCode.vue?vue&type=style&index=0&id=d04d7304&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04d7304",
  null
  
)

export default component.exports